import { FC } from "react";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { useStore } from "@/store/index";
import { useCurrency } from "@/utils/hooks/useCurrency";
import { useCurrencyConversion } from "@/utils/hooks/useCurrencyConversion";
import { formatPrice } from "@/utils/common/formatPrice";
import InfoCircleLine from "../../public/custom-icons/icons-2/icons/Info Circle/Line.svg";
import styles from "../../styles/detail/DetailAddToCart.module.scss";

const PackageDetailAddToCartBoxInfo: FC<{
    price: number;
    onClickInfo: () => void;
    showPrice?: boolean;
}> = ({ price, onClickInfo, showPrice = true }) => {
    const { clickConfirmDate } = useStore(state => state.checkoutState);
    const { currency } = useCurrency();
    const { convertPrice } = useCurrencyConversion();

    return (
        <MDBRow
            className={`${styles.priceContainer} ${styles.addToCartBoxInfoText} m-0 p-0`}
        >
            <MDBCol
                className="p-0 d-flex justify-content-center"
                size="6"
                center
            >
                <MDBRow className="d-inline-flex">
                    <MDBCol className="text-center">
                        <span className={`${styles.addToCartBoxPrice} pe-0`}>
                            {showPrice && clickConfirmDate
                                ? formatPrice(
                                      parseFloat(convertPrice(price)),
                                      currency
                                  )
                                : "-"}
                        </span>
                    </MDBCol>
                </MDBRow>
            </MDBCol>

            <MDBCol size="6" className="border-start border-2 ps-4 d-flex">
                <div className="d-flex justify-content-center flex-column">
                    <div
                        className={`${styles.paddingAddToCartBoxRightText} text-center p-0`}
                    >
                        Prices may vary based on tariffs and seasonal changes.
                    </div>

                    <div
                        style={{ cursor: "pointer" }}
                        onClick={onClickInfo}
                        className={`${styles.showMore} cursor-pointer ps-xxl-1 align-items-center text-decoration-underline d-flex justify-content-center`}
                    >
                        show more{" "}
                        <div className="pe-auto d-inline-flex">
                            <div className={`${styles.infoIcon} p-0`}>
                                <InfoCircleLine />
                            </div>
                        </div>
                    </div>
                </div>
            </MDBCol>
        </MDBRow>
    );
};

export default PackageDetailAddToCartBoxInfo;
